export default `
# Stánky

### (Net)Admins SH

Zajímá vás, jak funguje pravděpodobně největší síť spravovaná studenty? Jaké služby provozují
na svých serverech? Seznamte se s klubem Silicon Hill Studentské unie ČVUT!

### Vim

Jsme [#vimpivo](https://twitter.com/search?f=tweets&vertical=default&q=%23vimpivo&src=typd)
z @SUT_SH a máme rádi textový editor VIM. Na stánku vám ukažeme, co všechno umí a jak ho používat.

### [Bastlíři SH](http://macgyver.sh.cvut.cz/)

Dráty, žárovky, procáky, 8bity a jiné šváby… prostě veteš ze Strahovské Bastlírny (čti hackerpsace)
klubu Silicon Hill.

### [3D tisk SH](http://3dtisk.sh.cvut.cz/)

3D tisk SH je studentský projekt klubu Silicon Hill, který svým členům umožňuje seznámit se s
touto technologií.

### [LinuxMarket](https://www.linuxmarket.cz/)

Trička, hrnky, plyšoví tučňáci, knihy a mnoho dalšího na téma Linux, linuxové distribuce a open source

### [vpsFree](https://vpsfree.cz/)

Spolek lidí, kteří se rozhodli vybudovat vlastní platformu pro provoz virtuálních serverů,
která je hrazená samotnými členy.

### [Fedora](https://mojefedora.cz/)

Nejnovější vydání Fedory v akci, spousty samolepek a DVD s Fedorou.

### [OpenSUSE](https://www.opensuse.org/)
Vyzkoušejte nové openSUSE a diskutujte přímo s vývojáři této distribuce. Také budete mít šanci
vyhrát velké plyšáky.
`



// WEBPACK FOOTER //
// ./src/content/installfest/stands/text.js